import React from 'react'
import Wdata from '../Data/Wdata'
function World() {
  return (
    <div className="container">
            <div className="p-2 mb-3">
            {Wdata.map((a) => (
              <>
                <div className="d-flex my-4">
                  <div className="flex-shrink-0 worldtop">
                    <img
                      className="object-fit-cover world"
                      width={300}
                      height={200}
                      src={a.img}
                    />
                  </div>
                  <div className="flex-grow-1 ms-3 py-4 px-2">
                   <a href=""><h5>{a.title}</h5></a>
                   <p className="text-secondary pe-0">August 29, 2019</p>                   
                      <p className="text-secondary pe-0">{a.description}</p>                  
                  </div>
                </div>
              </>
            ))}
          </div>
     <nav aria-label="Page navigation example">
  <ul className="pagination mt-3">
    <li className="page-item"><a className="page-link me-2" href="#">Previous</a></li>
    <li className="page-item"><a className="page-link me-2" href="#">1</a></li>
    <li className="page-item"><a className="page-link link me-2" href="#">2</a></li>
    <li className="page-item"><a className="page-link me-2" href="#">3</a></li>
    <li className="page-item"><a className="page-link" href="#">Next</a></li>
  </ul>
</nav>

    </div>
  )
}

export default World
